import React, { useEffect, useState } from 'react';
import './LiveSavingsSection.css';

const sampleDeals = [
  { id: 1, title: '50% off on Swiggy Orders', discount: '50%', urgency: 'Ends in 2 hours!' },
  { id: 2, title: 'Flat ₹300 off on Amazon Electronics', discount: '₹300', urgency: 'Limited Stock!' },
  { id: 3, title: '30% off on Flipkart Fashion', discount: '30%', urgency: 'Today Only!' },
];

const LiveSavingsSection = () => {
  const [currentDealIndex, setCurrentDealIndex] = useState(0);
  const [totalSaved, setTotalSaved] = useState(1245700); // ₹12,45,700

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentDealIndex((prev) => (prev + 1) % sampleDeals.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  // Optional: simulate increasing savings every 5 sec
  useEffect(() => {
    const timer = setInterval(() => {
      setTotalSaved(prev => prev + Math.floor(Math.random() * 1000 + 500));
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const deal = sampleDeals[currentDealIndex];

  return (
    <div className="live-savings-section">
      <h2>💰 ₹{totalSaved.toLocaleString()} saved by our users this week!</h2>
      <div className="rotating-deal">
        <h3>🔥 {deal.title}</h3>
        <p><strong>Save:</strong> {deal.discount} | <span className="urgency">{deal.urgency}</span></p>
      </div>
    </div>
  );
};

export default LiveSavingsSection;
